/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * ModalCloseIcon - Auto-generated from icon.js
 */
export const ModalCloseIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M20 4L4 20" stroke="#333333" strokeWidth="2.5" strokeLinecap="square" strokeLinejoin="round" />
		<path d="M4 4L20 20" stroke="#333333" strokeWidth="2.5" strokeLinecap="square" strokeLinejoin="round" />
	</svg>
);

export default ModalCloseIcon;
